import React from 'react';
import PropTypes from 'prop-types';
import styledComponent from '../../utils/styledComponent';
import theme from '../../theme';

const StyledDiv = styledComponent('div', {
  textAlign: 'center',
  padding: theme.spacing.emptyStatePadding,
  color: theme.colors.textMuted,
  fontStyle: 'italic',
  background: theme.colors.bgCard,
  borderRadius: theme.radii.card,
  border: theme.borders.card,
  boxShadow: theme.shadows.card,
});

function PlaceholderTab({ tabName }) {
  return (
    <StyledDiv>
      {`Coming soon — the ${tabName} view will be built out in a future story.`}
    </StyledDiv>
  );
}

PlaceholderTab.propTypes = {
  tabName: PropTypes.string.isRequired,
};

export default PlaceholderTab;
